import {SportDisplayTimeFormat} from "./types";
import {IBasicGameOptions, ICountingGameOptions, ITimedGameOptions} from "@webng-types/write-model";

function zeroPad(num: number) {
  return num < 10 ? "0" + num : num.toString();
}

export function formatDisplayTimeSegment(format: SportDisplayTimeFormat, outputSeconds: number | undefined): string | undefined {
  if (outputSeconds !== undefined) {
    switch (format) {
      case "M'":
        return `${Math.ceil(outputSeconds / 60)}'`
      case "M":
        return `${Math.ceil(outputSeconds / 60)}`
      case "M.":
        return `${Math.ceil(outputSeconds / 60)}.`
      case "M:ss":
        return `${Math.floor(outputSeconds / 60)}:${zeroPad(outputSeconds % 60)}`
      case "MM:ss":
        return `${zeroPad(Math.floor(outputSeconds / 60))}:${zeroPad(outputSeconds % 60)}`
      case "":
      default:
        return ""
    }
  } else {
    return undefined
  }
}

// num_regular_phases/num_overtime_phases become loop bounds in calculatePossiblePhases. They come
// from a persisted game document (writable via UpdateGameOptionsModification with no server-side
// range validation), so an out-of-range or non-finite value must not reach that loop unclamped —
// otherwise a malformed/malicious document can force a multi-million-iteration synchronous loop on
// every render. Clamp to the real domain range (numRegularPhaseMap supports 2-4 regular phases, the
// highest num_overtime_phases across current sportstypes is 4).
function clampPhaseCount(value: number | undefined, fallback: number, min: number, max: number): number {
  const n = value ?? fallback
  if (!Number.isFinite(n)) return fallback
  return Math.min(max, Math.max(min, Math.trunc(n)))
}

export function ensureTimedGameOptions(options: IBasicGameOptions | undefined): Required<ITimedGameOptions> | undefined {
  if (options?._type === 'Tik::Model::Options::TimedGameOptions') {
    return {
      _type: "Tik::Model::Options::TimedGameOptions",
      timing_type: options.timing_type || "",
      num_regular_phases: clampPhaseCount(options.num_regular_phases, 1, 1, 4),
      overtime_phase_length: options.overtime_phase_length || 0,
      num_overtime_phases: clampPhaseCount(options.num_overtime_phases, 0, 0, 4),
      regular_phase_length: options.regular_phase_length || 300
    }
  } else {
    return undefined
  }
}

export function ensureCountingGameOptions(options: IBasicGameOptions | undefined): Required<ICountingGameOptions> | undefined {
  if(options?._type === "Tik::Model::Options::CountingGameOptions" && options.timing_type !== "") {
    return {
      _type: "Tik::Model::Options::CountingGameOptions",
      timing_type: options.timing_type || "",
      entity_type: options.entity_type || "km",
      regular_max: options.regular_max || 300
    }
  } else {
    return undefined
  }
}
